var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckCircleGreen = function SvgCheckCircleGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.416 4.667C15.593 4.667 5.161 15.134 5.161 28c0 12.867 10.432 23.334 23.255 23.334 12.823 0 23.256-10.468 23.256-23.334S41.239 4.667 28.416 4.667Zm9.67 20.252L28.24 34.65a3.833 3.833 0 0 1-2.727 1.128c-.99 0-1.987-.38-2.745-1.138l-3.997-3.887A1.95 1.95 0 0 1 18.727 28c.38-.393.887-.591 1.393-.591s.973.182 1.35.548l4.02 3.91 9.875-9.725a1.935 1.935 0 0 1 2.741.024 1.952 1.952 0 0 1-.02 2.752Z",
    fill: "#57C975"
  })));
};
export default SvgCheckCircleGreen;